import React, { useCallback, useEffect, useState } from 'react';
import { getSortState, translate, Translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { Box } from '@mui/material';
import { AUTHORITIES } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import { NoData } from 'app/shared/components/no-data/NoData';
import { PageFilters } from 'app/shared/components/page-filters/PageFilters';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { PaginationComponent } from 'app/shared/components/pagination/Pagination';
import { TableComponent } from 'app/shared/components/table-component/TableComponent';
import { IHeaderItem } from 'app/shared/interfaces/headerItemsInterface';
import { IListData } from 'app/shared/interfaces/listDataInterface';
import { ISearchTypes } from 'app/shared/interfaces/searchTypesInterface';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC } from 'app/shared/util/pagination.constants';
import { getEntities } from './allowed-companies.reducer';

export const AllowedCompanies = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const totalItems = useAppSelector(state => state.allowedCompanies.totalItems);
  const loading = useAppSelector(state => state.allowedCompanies.loading);
  const updateSuccess = useAppSelector(state => state.allowedCompanies.updateSuccess);
  const urlParams = new URLSearchParams(props.location.search);

  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );

  const allowedCompaniesList = useAppSelector(state => state.allowedCompanies.entities);
  const [nameSearch, setNameSearch] = useState<string>(urlParams.get('nameSearch') || '');

  const headers: IHeaderItem[] = [
    {
      key: 'company',
      sortable: true,
      component: <Translate contentKey="fleetSenseApp.allowedCompanies.company" />,
    },
  ];

  const data: IListData[] = [
    { type: 'text', value: 'company?.name' },
    { type: 'deleteButton', value: 'id' },
  ];

  const searchTypes: ISearchTypes[] = [
    {
      label: translate('fleetSenseApp.allowedCompanies.searchLabel'),
      placeholder: translate('fleetSenseApp.allowedCompanies.searchPlaceholder'),
      value: nameSearch,
      setValue: setNameSearch,
    },
  ];

  const getAllEntities = useCallback(() => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        nameSearch,
      })
    );

    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  }, [paginationState]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = (_, page) =>
    setPaginationState({
      ...paginationState,
      activePage: page,
    });

  const setActivePage = () => {
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
  };

  useEffect(() => {
    getAllEntities();
  }, [getAllEntities]);

  useEffect(() => {
    if (updateSuccess) {
      getAllEntities();
    }
  }, [updateSuccess, getAllEntities]);

  const { match } = props;

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', paddingTop: '16px', textAlign: 'center', padding: '24px' }}>
      <PageHeader
        headingId="allowed-companies-heading"
        headingDataCy="AllowedCompaniesHeading"
        contentKey="fleetSenseApp.allowedCompanies.home.title"
        buttonTextKey="fleetSenseApp.allowedCompanies.home.createLabel"
        match={match}
        showButton={isAdmin}
      />

      <PageFilters setActivePage={setActivePage} isAdmin={isAdmin} searchTypes={searchTypes} showFilters={['filters']} />

      {!loading && (
        <TableComponent listData={data} headers={headers} list={allowedCompaniesList} match={match} sortFunction={sort} pagination={paginationState} />
      )}

      {!loading && !allowedCompaniesList.length && <NoData title="Empresas permitidas" />}

      {loading && <Loading />}

      <PaginationComponent paginationState={paginationState} totalItems={totalItems} onChange={handlePagination} list={allowedCompaniesList} />
    </Box>
  );
};

export default AllowedCompanies;
